import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  ElementRef,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "[app-tracto-camion]",
  templateUrl: "./sigo-tracto-camion.component.html",
  styleUrls: ["./sigo-tracto-camion.component.scss"],
})
export class SigoTractoCamionComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input("ejesPrimerVehiculo") ejesPrimerVehiculo: number = 0;
  @Input("ejesSegundoVehiculo") ejesSegundoVehiculo: number = 0;
  @Input("mostrarDistancias") mostrarDistancias: boolean = true;
  // @ViewChild('seccionUltimoVehiculo', {
  //   static: false
  // }) seccionUltimoVehiculo: ElementRef;
  // @ViewChild('seccionUltimaDistancia', {
  //   static: false
  // }) seccionUltimaDistancia: ElementRef;
  debeMostrarDistancias: boolean = true;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes", changes);

    if (
      changes.ejesPrimerVehiculo &&
      changes.ejesPrimerVehiculo.firstChange &&
      changes.ejesSegundoVehiculo &&
      changes.ejesSegundoVehiculo.firstChange &&
      changes.mostrarDistancias &&
      changes.mostrarDistancias.firstChange
    ) {
      return false;
    }

    this.establecerSiDebeMostrarDistancias();

    //this.graficarDistanciasSegundoVehiculo();
  }

  ngOnInit(): void {
    this.debeMostrarDistancias = this.mostrarDistancias ? true : false;

    this.establecerSiDebeMostrarDistancias();
  }

  private establecerSiDebeMostrarDistancias = () => {
    if (this.mostrarDistancias) {
      this.debeMostrarDistancias = this.ejesPrimerVehiculo > 0;
    } else {
      this.debeMostrarDistancias = false;
    }
  };

  ngAfterViewInit() {
    //this.graficarDistanciasSegundoVehiculo();
  }

  obtenerListaEjesDelanteros = () => {
    let lista = [];

    for (let i = 0; i < this.ejesPrimerVehiculo; i++) {
      lista.push({ id: i + 1 });
    }

    return lista;
  };

  obtenerListaEjesPosteriores = () => {
    let lista = [];

    for (let i = 0; i < this.ejesSegundoVehiculo; i++) {
      lista.push({ id: i + 1 });
    }

    return lista;
  };

  private graficarDistanciasSegundoVehiculo = () => {
    if (!this.validarSiDebeGraficarDistancias()) return false;

    setTimeout(() => {
      const intEje = 35;
      const intMaxEjes = 9 * intEje;

      let sizeEjes = intEje * this.ejesSegundoVehiculo;

      if (sizeEjes < intMaxEjes) {
        //let letterE = this.seccionUltimoVehiculo.nativeElement.offsetWidth - (sizeEjes/2)
        //this.seccionUltimaDistancia.nativeElement.style.width = letterE + "px"
      } else {
        //var letraE = document.getElementById('medidaE')
        //this.seccionUltimaDistancia.nativeElement.style.width = (sizeEjes/2) + "px"
      }
    }, 100);
  };

  private validarSiDebeGraficarDistancias = () => {
    if (!this.debeMostrarDistancias) return false;

    return true;
  };
}
